export default __webpack_public_path__ + "static/media/image-main-3-m@3x.1927c243.png";